export default [
    {
        path: '/home',
        name: 'home',
        meta: {
            title: '市场',
            // header1: true,
            // market: true,
            keepAlive: true,
            hasBottom: true,

            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
        },
        component: () => import('./Home')
    },
    // 商品详情
    {
        path: '/goods',
        name: 'goods',
        meta: {
            title: '市场',
            unPullRefresh: true,
            market: true
        },
        component: () => import('./Goods')
    },
    //订单
    {
        path: '/order',
        name: 'order',
        meta: {
            title: '市场',
            market: true,
            unPullRefresh: true
        },
        component: () => import('./Order')
    },
    // 支付成功
    {
        path: '/paysuccess',
        name: 'paysuccess',
        meta: {
            title: '市场',
            market: true
        },
        component: () => import('./PaySuccess')
    },
    // 搜索
    {
        path: '/search',
        name: 'search',
        meta: {
            title: '市场',
            market: true,
            header4: true
        },
        component: () => import('./Search')
    },
    {
        path: '/choose',
        name: 'choose',
        meta: {
            title: '交易/出售',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            hasBottom: true
        },
        component: () => import('./Choose')
    }
]